import { render, staticRenderFns } from "./AutoCloseRightLeft.vue?vue&type=template&id=2f4055e8&scoped=true&"
import script from "./AutoCloseRightLeft.vue?vue&type=script&lang=js&"
export * from "./AutoCloseRightLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4055e8",
  null
  
)

export default component.exports